import { compose, withProps } from "recompose";
import Settings from "./Settings";

export default compose(withProps((props) => ({ isAdmin: true })))(Settings);
